import { SharedStripeConfig } from '.'
import { AiUserSubscription, BillingCycle } from '../../types'
import { BaseTier, CurrencySymbols, TrainingSpeed } from './BaseTier'

export type FreeTierType = FreeTier

class FreeTier extends BaseTier {
  readonly subscriptionType = AiUserSubscription.FREE
  readonly subscriptionLevel = 1
  readonly vocalLimitMinutes = 10
  readonly downloadMsPerMonth = 0
  readonly textToSpeechCharacterLimit = 300
  readonly inferenceSecondsPerMonth = 900
  readonly advancedSettingsEnabled = true
  readonly artistVoiceModelsEnabled = false
  readonly textToSpeechCharacterConverts = 300
  readonly modelSlots = 0

  // training stuff
  readonly trainingSpeed = TrainingSpeed.NORMAL
  readonly maxTrainingDatasetMb = 150
  readonly maxTrainDatasetFileSizeMb = 150
  readonly maxTrainingDatasetDurationMinutes = 10
  readonly maxYoutubeTrainingVideoLengthMinutes = 0
  readonly maxMlTrainingJobsPerMonth = 3
  readonly youtubeConvertsPerDay = Infinity

  readonly currencySymbol = CurrencySymbols.USD
  readonly monthlyPrice = 0
  readonly annualPrice = 0

  getPriceId(_billingCycle: BillingCycle, _isProd: boolean) {
    return null
  }
}

const freeTierInstance = new FreeTier()

export const getFreeTierPriceId = (billingCycle: BillingCycle, isProd: boolean) => {
  return SharedStripeConfig.subscriptionPriceIds(isProd)[billingCycle][AiUserSubscription.FREE][0]
}

export { freeTierInstance as FreeTier }
